import React from 'react';
import { vendors } from '../../../data/constant';

function StagingModal({ tData, sData }) {

    return (
      <table className="table table-striped" style={{ textAlign: "left" }}>
        <thead className="thead-light">
          <tr>
            <th>Transactional Data</th>
            <th>{vendors.find(v => v.value === tData.vendorId) ? vendors.find(v => v.value === tData.vendorId).name : null} Staging Details</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
               {Object.keys(tData).map((k, i) =>
                 <div className="div-table" key={i}>
                   <div style={{ position: 'relative', overflowX: 'auto', textAlign: 'left' }}>{k} : {tData[k].toString()}</div>                 </div>
               )}
            </td>
            <td>
               {sData && Object.keys(sData).map((k, i) =>
                 <div className="div-table" key={i}>
                   <div style={{ position: 'relative', overflowX: 'auto', textAlign: 'left' }}>{k} : {sData[k].toString()}</div>              </div>
               )}
            </td>
          </tr>
        </tbody>
      </table>
    );
}

export default React.memo(StagingModal);